import React from 'react';
import MainLayout from '../../layouts/MainLayout';

export const RSMList = () => {
  return <MainLayout></MainLayout>;
};
